import { connectInstructions } from "../../util/redux";
import TappingInstructionsComponent from "../../components/tapping/instructions";

const TappingInstructions = connectInstructions(TappingInstructionsComponent);

export default TappingInstructions;
